"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.scrollToOption = exports.scrollTo = void 0;
var _idBuilder = require("./idBuilder");
var scrollTo = exports.scrollTo = function scrollTo(id) {
  var elem = document.getElementById(id);
  if (elem) {
    var elemPosition = elem.getBoundingClientRect().top;
    var screenPosition = window.scrollY || window.pageYOffset;
    var newPosition = elemPosition + screenPosition - 105; // offsets the sticky header

    // until we completely move away from IE
    if (navigator.userAgent.match(/Trident/)) {
      window.scrollTo(0, newPosition);
    } else {
      window.scrollTo({
        left: 0,
        top: newPosition,
        behavior: 'smooth'
      });
    }
    return elem;
  }
  return null;
};
var scrollToOption = exports.scrollToOption = function scrollToOption(optionId) {
  return scrollTo((0, _idBuilder.buildOptionId)(optionId));
};
//# sourceMappingURL=navigation.js.map